import { SortingFields } from "./sortingFields";
import { SortingOrders } from "./sortingOrders";

export const reviewListQueryData = {
  page: 1,
  limit: 15,
  sortOrder: SortingOrders.DESC,
  sortField: SortingFields.createdAt,
};
